<script>
  import { link, location } from 'svelte-spa-router';
  import active from 'svelte-spa-router/active';
  import FaArrowLeft from 'svelte-icons/fa/FaArrowLeft.svelte';
  import FaArrowRight from 'svelte-icons/fa/FaArrowRight.svelte';
  import FaBars from 'svelte-icons/fa/FaBars.svelte';
  import FaRegFilePdf from 'svelte-icons/fa/FaRegFilePdf.svelte';
  import Container from './layout/container.svelte';

  import Sidebar from './sidebar.svelte';
  import navegacaoStore from '../store';

  let dados;

  navegacaoStore.subscribe((dadosStore) => {
    dados = dadosStore;
  });

  const openSidebar = () =>
    navegacaoStore.update((dadosStore) => {
      return { ...dadosStore, sidebarAberta: true };
    });

  const updatePaginaAtual = () => {
    navegacaoStore.update((dadosStore) => {
      return { ...dadosStore, paginaAtual: Number($location.split('/')[1]) };
    });
  };
</script>

<!-- <footer> -->
<div class="container">
  <div class="footer">
    <p>
      Trilha de aprendizagem do MÓDULO {dados.modulo}.
    </p>
    <div class="trilha">
      <div class="progress">
        <div
          class="progress-bar"
          role="progressbar"
          style="width: {$location.split('/')[1]
            ? (Number($location.split('/')[1]) / dados.paginas.length) * 100
            : (1 / dados.paginas.length) * 100}%;"
          aria-valuenow="0"
          aria-valuemin="0"
          aria-valuemax="100"
        />
      </div>
      <div class="trilha-nome">
        {#each dados.paginas as pagina, i}
          {#if i < dados.paginas.length}
            {#if i === 0}
              <a
                on:click={updatePaginaAtual}
                href="/{i + 1}"
                use:link
                class:active={Number($location.split('/')[1]) === 1 || $location === '/'}
                class="unidade"
              >
                {pagina}
              </a>
            {:else}
              <a
                href="/{i + 1}"
                use:link
                use:active={{ className: 'active' }}
                class="unidade"
                on:click={updatePaginaAtual}
              >
                {pagina}
              </a>
            {/if}
            <!-- {' - '} -->
          {/if}
        {/each}
      </div>
    </div>

    <div class="paginacao">
      <div on:click={() => window.scrollTo(0, 0)} class="voltar">Voltar ao topo</div>
      <div class="setas">
        <a
          on:click={updatePaginaAtual}
          class="prev"
          class:visivel={Number($location.split('/')[1]) > 1}
          href="#/{Number($location.split('/')[1]) - 1}"
        >
          <svg
            width="16"
            height="21"
            viewBox="0 0 22 29"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1.34178 16.9273C-0.307498 15.7293 -0.307501 13.2707 1.34178 12.0727L16.487
                    1.07211C18.4701 -0.368305 21.25 1.04836 21.25 3.49939L21.25 25.5006C21.25 27.9516
                    18.4701 29.3683 16.487 27.9279L1.34178 16.9273Z"
              fill="white"
            />
          </svg>
        </a>
        <a
          class="next"
          class:visivel={Number($location.split('/')[1]) < dados.paginas.length}
          on:click={updatePaginaAtual}
          href="#/{Number($location.split('/')[1]) ? Number($location.split('/')[1]) + 1 : 2}"
        >
          <svg
            width="16"
            height="21"
            viewBox="0 0 22 29"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M20.6582 12.0727C22.3075 13.2707 22.3075 15.7293 20.6582 16.9273L5.51304
                    27.9279C3.52994 29.3683 0.75 27.9516 0.750001 25.5006L0.750002 3.49939C0.750002
                    1.04837 3.52993 -0.368309 5.51304 1.07211L20.6582 12.0727Z"
              fill="white"
            />
          </svg>
        </a>
        <!-- {/if} -->
      </div>
    </div>
    <!-- </Container> -->
  </div>
</div>

<!-- </footer> -->
<style>
  .footer {
    background: url(../assets/images/identity/footer-bkg.svg);
    margin-top: 80px;
    padding: 30px 15px 10px 0;
    font-family: var(--FONT_INTER);
    background-repeat: no-repeat;
    background-size: cover;
    position: relative;
    z-index: 1;
  }

  .progress {
    position: relative;
    width: 100%;
    background-color: var(--BRANCO);
    border: 1px solid var(--VERDE);
    box-sizing: border-box;
    border-radius: 0 20px 20px 0;
    height: 30px;
    z-index: 1;
  }

  .progress-bar {
    background: var(--VERDE);
    transition: all 200ms ease;
    position: relative;
    z-index: 1;
  }

  .trilha::before {
    content: '';
    width: 20px;
    height: 50px;
    background: var(--VERDE);
    position: absolute;
    left: -20px;
    top: 15px;
    z-index: 2;
    border-radius: 15px 0 0 15px;
  }

  .trilha::after {
    content: '';
    width: 17px;
    height: 18px;
    background: var(--VERDE_ESCURO);
    position: absolute;
    left: -17px;
    top: 45px;
    z-index: 3;
    border-radius: 30px 0 0 42px;
  }

  p {
    font-weight: 700;
    margin: 0;
    font-size: 18px;
    color: var(--VERDE);
  }

  .footer p {
    margin: 0 20px;
  }

  .trilha {
    padding: 15px 0;
    color: #fff;
    position: relative;
  }

  .trilha-nome {
    display: flex;
    justify-content: space-evenly;
    margin-top: 10px;
  }

  a {
    text-decoration: underline;
    font-size: 14px;
    /* line-height: 2.4; */
    color: var(--VERDE);
  }

  .voltar {
    cursor: pointer;
    color: #fff;
    font-weight: 500;
    text-transform: uppercase;
    margin: 0 0 0 20px;
    font-size: 12px;
  }

  a:hover,
  .voltar:hover,
  .trilha :global(.active) {
    /* color: #fff; */
  }
  .trilha :global(.active) {
    font-weight: 700;
    /* color: #fff; */
  }

  .paginacao {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .setas {
    display: flex;
  }
  .setas a {
    background-repeat: no-repeat;
    background-position: center center;
    display: flex;
    align-items: center;
    justify-content: center;
    /* width: 30px; */
    /* height: 30px; */
    pointer-events: none;
    opacity: 0.9;
    filter: brightness(0.6);
  }

  .setas a.visivel {
    /* background: var(--COR_MODULO);
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.2); */
    /* background: var(--HEX_BTN); */
    /* background-color: #e5332a; */
    background-repeat: no-repeat;
    background-position: center center;
    pointer-events: all;
    opacity: 0.9;
    filter: brightness(1);
  }

  .setas a:hover {
    opacity: 1;
  }

  .setas a svg {
    height: 24px;
  }

  .setas .prev {
    padding-right: 3px;
  }
  .setas .next {
    padding-left: 3px;
    /* margin-left: 20px; */
  }
  .unidade {
    text-decoration: none;
    /* text-transform: uppercase; */
  }
  @media (max-width: 800px) {
    .trilha-nome {
      display: grid;
      grid-template-columns: 1fr;
      gap: 5px;
    }
    .unidade {
      justify-self: center;
    }
    .trilha-nome a {
      font-size: 16px;
    }
    p {
      font-size: 13px;
      text-align: center;
    }
    .container {
      padding: 0;
    }

    .container {
      margin-left: 0;
      margin-right: 0;
      width: 100%;
    }

    .footer {
      padding: 20px 15px 10px 15px;
    }
    .trilha::before {
      display: none;
    }
    .trilha::after {
      display: none;
    }
    .progress {
      border-radius: 20px;
    }
  }
</style>
